import { Command } from 'commander';
import prompts from 'prompts';
import { WorkflowManager } from '../core/workflow-manager';
import { logger } from '../utils/logger';

export function createStartCommand(): Command {
  const command = new Command('start');

  command
    .description('Start a workflow')
    .argument('<type>', 'Workflow type (feature, bugfix, refactor)')
    .option('-n, --name <name>', 'Workflow name')
    .option('-d, --description <desc>', 'Workflow description')
    .option('-y, --yes', 'Skip confirmation')
    .action(async (type, options) => {
      try {
        const manager = new WorkflowManager();

        // Get workflow details
        let name = options.name;
        let description = options.description;

        if (!options.yes && (!name || !description)) {
          const answers = await prompts([
            {
              type: !name ? 'text' : null,
              name: 'name',
              message: 'Workflow name:',
              initial: `${type}-${Date.now()}`
            },
            {
              type: !description ? 'text' : null,
              name: 'description',
              message: 'Description (optional):'
            }
          ]);

          name = name || answers.name;
          description = description || answers.description;
        }

        await manager.startWorkflow(type, { name, description });
      } catch (error: any) {
        logger.error('Failed to start workflow:', error.message);
        if (process.env.DEBUG) {
          console.error(error);
        }
        process.exit(1);
      }
    });

  return command;
}